enum DriverContractListingViewMode {
  TAXI = "TAXI",
  RAILY = "RAILY",
}

export default DriverContractListingViewMode;
